module.exports = __webpack_public_path__ + "img/img22.c1c0cfe9.png";